import 'slick-carousel';

$('.featured-agencies').slick({
    arrows: false,
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: true,
    lazyLoad: 'ondemand',
    responsive: [
        {
            breakpoint: 1600,
            settings: {
                slidesToScroll: 4,
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 1100,
            settings: {
                slidesToScroll: 3,
                slidesToShow: 3,
            },
        },
        {
            breakpoint: 900,
            settings: {
                slidesToScroll: 2,
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 576,
            settings: {
                infinite: false,
                slidesToScroll: 1,
                slidesToShow: 1.3,
            },
        },
    ],
    slidesToScroll: 5,
    slidesToShow: 5,
    speed: 500,
});

$('.featured-agencies-prev').on('click', () => {
    $('.featured-agencies').slick('slickPrev');
});

$('.featured-agencies-next').on('click', () => {
    $('.featured-agencies').slick('slickNext');
});